import { useEffect, useMemo, useRef, useState, useContext } from 'react';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';
import axios from '../../axios';
import AuthContext from "../../AuthContext";
import { Menu, Paper } from '@mantine/core';

const Example = ({ updateProductModalSetting, handlePageUpdate, centre, userType }) => {
  const authContext = useContext(AuthContext);

  const columns = useMemo(
    () => [
      {
        accessorKey: 'sector_name',
        header: 'Sector Name',
        size: 250,
      },
      ...(authContext.userType === 'Superadmin' ? [
        {
          accessorKey: 'centre_name',
          header: 'Centre Name',
        },
      ] : [])
    ],
    [authContext.userType]
  );

  const rowVirtualizerInstanceRef = useRef(null);

  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [sorting, setSorting] = useState([]);

  useEffect(() => {
    axios.post('/sector/getall',  {
        centre_id: centre,
      
    })
      .then((res) => setData(res.data))
      .catch((err) => console.log(err))
      .finally(() => setIsLoading(false));
  }, [centre, handlePageUpdate]);

  useEffect(() => {
    if (rowVirtualizerInstanceRef.current) {
      rowVirtualizerInstanceRef.current.scrollToIndex(0);
    }
  }, [sorting]);

  const table = useMantineReactTable({
    data,
    columns,
    enableGlobalFilter: true,
    enableColumnFilterModes: true,
    enablePinning: true,
    enablePagination: true,
    enableMultiSort: true, 
    columnFilterDisplayMode:"popover",
    paginationDisplayMode:"pages",
    positionToolbarAlertBanner:"bottom",
    enableColumnResizing: true,
    enableColumnFilter: true,
    enableColumnSelection: true,
    enableGlobalFilter: true,
    enableGlobalFilterModes: true,
    enableStickyHeader: true,
    enableColumnSticky: true,
    enableRowNumbers: true,
    enableRowActions: true,
    renderRowActionMenuItems: ({ row }) => (
      <Menu.Item onClick={() => updateProductModalSetting(row.original)}>Edit</Menu.Item>
    ),
  });

  return (
    <Paper shadow="sm" p="lg" withBorder>
                  <div style={{ overflowX: 'auto', overflowY: 'auto', maxHeight: '500px', width: '100%' }}>

      <MantineReactTable
        table={table}
        striped
        highlightOnHover
        horizontalSpacing="md"
        verticalSpacing="sm"
        fontSize="sm"
        withColumnBorders
        borderRadius="md"
        withGlobalFilter
        height={400}
        rowVirtualizerInstanceRef={rowVirtualizerInstanceRef}
        enablePagination={true}
      />
      </div>
    </Paper>
  );
};

export default Example;
